/**
 * Операции страницы диагностики: опрос метрик, инцидентов, таймлайна.
 * Они часто оказываются «ключевой операцией» в карточке, но не объясняют
 * причину срабатывания — это служебный трафик самой панели.
 */
const SERVICE_OPERATION_PREFIXES = ["root.diagnostics."] as const;

export function isServiceOperation(name: string | null | undefined): boolean {
	if (!name) return false;

	return SERVICE_OPERATION_PREFIXES.some((prefix) => name.startsWith(prefix));
}
